import { WebsocketContext } from "../contexts/websocketContext";
import useSocket from "../hooks/useWebsocket";
import React, { useContext } from "react";
import { ImExit } from "react-icons/im";
import StyledButton from "./StyledButton";
import useTranslatePageText from "@natklok/hooks/useTranslatePageText";

const LeaveQuizButton: React.FC<{
  pauseWindowIsOpen?: boolean;
  endGame?: boolean;
  style?: React.CSSProperties;
  fullWidth?: boolean;
  size?: "small" | "medium";
}> = ({ endGame = false, pauseWindowIsOpen = false, size = "small", fullWidth = false, style }) => {
  const { isMultiplayerHost } = useContext(WebsocketContext);
  const { wsLeaveRoom, wsEndGame } = useSocket();
  const translatePageText = useTranslatePageText();

  const handleClick = () => {
    const text = isMultiplayerHost
      ? translatePageText("forTeachers.sureToFinishGame")
      : translatePageText("forTeachers.sureToLeave");
    const confirmed = window.confirm(text);
    if (confirmed && !endGame) wsLeaveRoom();
    else if (confirmed && endGame) wsEndGame();
  };

  return (
    <StyledButton
      label={
        isMultiplayerHost
          ? translatePageText("forTeachers.finish")
          : translatePageText("forTeachers.leave")
      }
      variant="tertiary"
      size={size}
      fullWidth={fullWidth}
      icon={<ImExit />}
      onClick={() => {
        handleClick();
      }}
      style={{
        padding: pauseWindowIsOpen ? 7 : "7px 13px",
        background: "transparent",
        color: "white",
        boxShadow: undefined,
        ...style,
      }}
    />
  );
};

export default LeaveQuizButton;
